<template lang="pug">
  app-modal(
    :titulo="'Visualizar solicitações'",
    @closeModal="closeModal()",
    :width="width",
    :height="700"
    :bodyStyle="{height: 'auto', padding: '0'}"
  )
    template(slot="body")
      app-modal-visualiza-pdf(
        v-if="showModalVisualizaPdf",
        @closeModal="closeModalVisualizaPdf",
        :titulo="tituloModal",
        :tipo="tipoModal",
        :conteudo="conteudoModal",
        :isVTN="false",
        :isImagem="isImagem"
        :tituloDocumento="tituloDocumento"
      )
      div.extra-margin-bottom(v-for="item in solicitacoesInformacao", :key="item.id")
        p.bold
          | Solicitações: &nbsp Informação
        el-collapse(v-model='abaAtiva')
          el-collapse-item
            template(slot="title")
              div.flex.title.full-width
                span {{item.responsavel}}
                span.date {{formatData(item.requerimento.dataEnviada)}} &nbsp

            app-display(
              label="Setor Origem:",
              :content="item.setorOrigem",
            )
            app-display(
              label="Setor Requerido:",
              :content="item.setorRequerido",
            )
            app-display(
              label="Responsável:",
              :content="item.responsavel",
            )
            app-display(
              label="Data de Vencimento:",
              :content="formatData(item.dataVencimento)",
            )
            p
              b Despacho:
            p(v-html="item.requerimento.conteudo")

            el-row
              el-table(
                :data='item.requerimento.anexoList',
                stripe
              )
                div(slot='empty')
                  span Não há anexos disponíveis.
                el-table-column.td-column-anexo(
                  prop='nome',
                )
                el-table-column.td-column-anexo(
                  align="center",
                  width="85"
                )
                  template(slot-scope='scope')
                    el-tooltip.btn-actions(
                      effect='dark',
                      :content="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar Documento' ",
                      placement="left"
                    )
                      el-button.button(
                        v-if="scope.row && (isEstadoMA || isEstadoAP)",
                        @click="abrirDocumento(scope.row)"
                        :disabled="!isDocumentoParaVisualizacao(scope.row)"
                      )
                        font-awesome-icon(icon="eye", size="lg")
                    app-action-button(
                      icone="download",
                      nome="file_download",
                      @click="baixarAnexo(scope.row)",
                      hoverColor="#009f61",
                      text="Baixar anexo"
                    )

            el-collapse.collapse(v-model='abaAtiva')
              el-collapse-item(
                v-for="msg in item.mensagemList",
                :key="msg.id",
                :name='msg.id',
              )
                template(slot="title")
                  div.flex.title.full-width
                    span {{ msg.nomeRemetente }}
                    span {{ formatData(msg.dataEnviada) }} &nbsp

                el-row.margin-top
                  p
                    b Resposta:
                  p(v-html="msg.conteudo")

                el-row
                  el-table(
                    :data='msg.anexoList',
                    stripe
                  )
                    div(slot='empty')
                      span Não há anexos disponíveis.
                    el-table-column.td-column-anexo(
                      prop='nome',
                    )
                    el-table-column.td-column-anexo(
                      align="center",
                      width="85"
                    )
                      template(slot-scope='scope')
                        el-tooltip.btn-actions(
                        effect='dark',
                        :content="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar Documento' ",
                        placement="left"
                      )
                        el-button.button(
                          v-if="scope.row && (isEstadoMA || isEstadoAP)",
                          @click="abrirDocumento(scope.row)"
                          :disabled="!isDocumentoParaVisualizacao(scope.row)"
                        )
                          font-awesome-icon(icon="eye", size="lg")
                        app-action-button(
                          icone="download",
                          nome="file_download",
                          @click="baixarAnexo(scope.row)",
                          hoverColor="#009f61",
                          text="Baixar anexo"
                        )
</template>

<script>
import moment from 'moment'
import { meses } from '@/utils/constantes'
import { mapActions } from 'vuex'
import AppActionButton from '@/components/AppActionButton'
import AppModal from '@/components/AppModal'
import AppDisplay from '@/components/AppDisplay'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import utils from '@/utils/utils'
const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {

  components: {
    AppModal,
    AppDisplay,
    AppActionButton,
    AppModalVisualizaPdf
  },

  props: {
    width: {
      type: Number,
      default: 850
    },
    solicitacoesInformacao: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      abaAtiva: undefined,
      moment,
      showModalVisualizarProcesso: false,
      tituloModal: null,
      tipoModal: null,
      conteudoModal: null,
      showModalVisualizaPdf: false,
      isImagem: false,
      tituloDocumento: ''
    }
  },

  methods: {
    ...mapActions({
      baixarDocumento: 'conversas/baixarDocumento'
    }),
    closeModal () {
      this.$emit('closeModal')
    },

    formatData (data) {
      if (!data) return '-'

      const dataFormatada = data.split('/')

      return dataFormatada[0] + ` de  ${meses.get(dataFormatada[1])} de ` + dataFormatada[2]
    },
    baixarAnexo (anexo) {
      this.baixarDocumento(anexo)
    },
    abrirImagem (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    abrirDocumento (documento) {
      this.tipoModal = 'DOCUMENTO_MENSAGEM'
      this.tituloModal = 'Documento'
      this.conteudoModal = documento.id
      this.isImagem = this.abrirImagem(documento)
      this.showModalVisualizaPdf = true
      this.tituloDocumento = 'Documento'
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  },
  computed: {
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    isEstadoAP () {
      return process.env.ESTADO === 'ap'
    }
  }
}

</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

  .extra-margin-bottom {
    padding: 10px;
  }

    .full-width {
    width: -webkit-fill-available;
  }

  .collapse {
    margin-top: 30px;
  }

  p.message {
    width: 80%;
    margin: 0 auto;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-weight: 400;
  }

  .date {
    align-self: flex-end;
    text-align: end;
  }

  p {
    margin-bottom: 1vh;
    font-size: 14px;
    b {
      color: $font-dark-color;

    }
  }

  .text {
    color: $font-color;
  }

  .bold {
    font-weight: bold;
  }
  .button {
    border: none;
    background: none;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/gerais/AppModalListaSolicitacoesInformacao.vue